export const getFeatureFlagQuery = () => `
  query getAllFeatureFlags {
    features {
      name
      active
    }
  }`;
